export default __webpack_public_path__ + "static/media/ball.6dff42b9.png";